import { MedicalFacility, ApiResponse } from "../../types";
import apiClient from "../api/client";

// Create a mutable copy for operations

export const clinicService = {
  getList: async (
    page: number = 1,
    pageSize: number = 20,
  ): Promise<ApiResponse<MedicalFacility[]>> => {
    try {
      // Real API call using axios instance (accessToken is automatically added by interceptor)
      const response = await apiClient.get<ApiResponse<MedicalFacility[]>>(
        "/admin/medical-facilities/",
        {
          params: {
            page,
            page_size: pageSize,
          },
        },
      );

      return response.data;
    } catch (error) {
      // Fallback to mock data if API fails (for development)
      return {
        success: false,
        data: [],
      };
    }
  },

  getDetail: async (id: number): Promise<ApiResponse<MedicalFacility>> => {
    try {
      const response = await apiClient.get<ApiResponse<MedicalFacility>>(
        `/admin/medical-facilities/${id}/`,
      );
      return response.data;
    } catch (error) {
      return {
        success: false,
        data: {} as MedicalFacility,
      } as ApiResponse<MedicalFacility>;
    }
  },

  create: async (
    data: Partial<MedicalFacility> & {
      username?: string;
      password?: string;
      term?: string;
    },
  ): Promise<ApiResponse<MedicalFacility>> => {
    try {
      // Real API call
      const response = await apiClient.post<ApiResponse<MedicalFacility>>(
        "/admin/medical-facilities/",
        data,
      );
      return response.data;
    } catch (error) {
      // Fallback to mock data
      return {
        success: false,
        data: {} as MedicalFacility,
      } as ApiResponse<MedicalFacility>;
    }
  },

  update: async (
    id: number,
    data: Partial<MedicalFacility> & { term?: string },
  ): Promise<ApiResponse<any>> => {
    try {
      // Real API call
      const response = await apiClient.put<ApiResponse<MedicalFacility>>(
        `/admin/medical-facilities/${id}/`,
        data,
      );
      return response.data;
    } catch (error) {
      // Fallback to mock data
      console.warn("API call failed, using mock data:", error);
      return {
        success: false,
        data: {} as MedicalFacility,
      } as ApiResponse<any>;
    }
  },

  clinicDetail: async (): Promise<ApiResponse<MedicalFacility>> => {
    try {
      const response = await apiClient.get<ApiResponse<MedicalFacility>>(
        "/medical-facilities/profile/",
      );
      return response.data;
    } catch (error) {
      return {
        success: false,
        data: {} as MedicalFacility,
      } as ApiResponse<MedicalFacility>;
    }
  },
};
